// Copyright (c) 2021 Davide Gironi
// Please refer to LICENSE file for licensing information.

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

// load config
import Config from './config/config';

i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: 'en',
        whitelist: Config.languages,
        detection: {
            checkWhitelist: true,
        },
        debug: true,
        interpolation: {
            escapeValue: false,
        }
    });

export default i18n;